import { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useServices } from '@services';
import { Table, AsyncButton } from '@component';
import PulseLoader from 'react-spinners/PulseLoader';
import Swal from 'sweetalert2/dist/sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

export const ModelTable = ({
  model,
  query,
  collection,
  onViewRow,
  columns,
  version,
  className,
  defaultSortBy,
  canDelete = true,
}) => {
  const { db } = useServices();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState();

  const deleteItem = id => {
    if (process.env.REACT_APP_ALLOW_DELETE !== 'true') return Promise.resolve();
    return db
      .collection(collection)
      .doc(id)
      .delete()
      .then(() => {
        toast.success(`${model.name} item deleted`);
      })
      .catch(err => {
        console.log('🚀 ~ file: ModelTable.jsx ~ line 21 ~ ModelTable ~ err', err);
        toast.error(`Unknown error deleting ${model.name} item`);
      });
  };

  const confirmDeleteItem = id => {
    return Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to delete this ${model.name} item?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(result => {
      if (result.value) {
        return deleteItem(id).then(() => loadList());
      }
      return Promise.resolve();
    });
  };

  const loadList = useCallback(mounted => {
    const loadListQuery = query
      ? query().get()
      : db
          .collection(collection)
          // .where('isActive', '==', true)
          .get();

    return loadListQuery
      .then(result => {
        if (!mounted.current) return;
        setList(
          result.docs.map(doc => {
            return { ...doc.data(), id: doc.id };
          })
        );
      })
      .catch(err => {
        if (!mounted.current) return;
        console.log('🚀 ~ file: ModelTable.jsx ~ line 38 ~ loadList ~ err', err);
        toast.error(`An error occured while loading the ${model.name} list.`);
      })
      .finally(() => {
        if (mounted.current) setLoading(false);
      });
  }, [db, collection, model.name, query]);

  useEffect(() => {
    const mounted = { current: true };
    setLoading(true);
    loadList(mounted);
    return () => {
      mounted.current = false;
    };
  }, [version, loadList]);

  const rowActions = row => (
    <div className="flex justify-center items-center">
      <button onClick={() => onViewRow(row.original)} className="text-primary-500 px-4">
        View
      </button>
      {canDelete && (
        <AsyncButton onClick={() => confirmDeleteItem(row.original.id)} className="text-primary-500 px-4">
          Delete
        </AsyncButton>
      )}
    </div>
  );

  if (loading) return <PulseLoader></PulseLoader>;

  return (
    <div className={className}>
      {list && (
        <Table columns={columns} data={list} actions={rowActions} defaultSortBy={defaultSortBy} />
      )}
    </div>
  );
};
